/* tempexp_18086-start */
import { Spacing } from '@vkontakte/vkui';
import classNames from 'clsx';
import React from 'react';
import type { BillingReferralProgram } from 'reactApp/modules/billingData/billingData.types';

import { ReferralUserItem } from './ReferralUserItem';
import styles from './ReferralUsersBlock.css';

interface ReferralUsersBlockProps {
    list: BillingReferralProgram[];
    onClick(item: BillingReferralProgram): void;
    isMobile?: boolean;
}

export function ReferralUsersBlock({ list, isMobile, onClick }: ReferralUsersBlockProps) {
    const spaceSize = isMobile ? 0 : 32;
    return list?.length ? (
        <div className={classNames(styles.rootBlock, { [styles.rootMobile]: isMobile })}>
            {list.map((user) => (
                <ReferralUserItem user={user} key={user.id} onClick={onClick} />
            ))}
            <Spacing size={spaceSize} />
        </div>
    ) : (
        <Spacing size={spaceSize} />
    );
}

/* tempexp_18086-end */
